import React, { useEffect, useState } from 'react';
import {Card} from 'antd';
import {changeServicePage, clearClassBookingDetails} from '../../../redux/actions';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import '../public-appointment.scss';
import useQuery from '../../../hooks/useQuery';
import Axios from 'axios';
import { BASE_URL_WEB } from '../../../utility/constants';
const PublicSessionsCardList = ({
  servicesList,
  setTrainerList,
  setSelectedService,
  selectedService,
}) => {
  const dispatch = useDispatch();
  const publicUser = useSelector(state => state.publicUser);
  const authDetails = useSelector(state => state.auth);
  const history = useHistory();
  const branchId = useSelector(state => state.auth.companyData?.branch?.id);
  const branchIdUrlQuery = useQuery().get('branchId');
  const [companyData, setCompanyData] = useState([])
  useEffect(async()=>{
    if(authDetails?.companyData?.CTCM === undefined){
      const companyId = publicUser?.companyId;
      const response = await Axios({
            method: 'GET',
            url: `${BASE_URL_WEB}public-company-data/${companyId}`,
          });
          setCompanyData(response.data);
          console.log('public-company-data: ', response.data);
  } else {
    setCompanyData(authDetails?.companyData);
  }
},[publicUser])
  return (
    <div className="row">
      {companyData?.CTCM === false && companyData?.booking_max_days !==null &&
      // authDetails?.companyData?.booking_max_days !== null &&
      // authDetails?.companyData?.booking_max_days !== undefined &&
      servicesList?.length > 0 ? (
        servicesList?.some(({trainer}) =>
          trainer?.some(
            x =>
              x.branchTrainersBranchId === (branchId || branchIdUrlQuery) &&
              x.availability !== false
          )
        ) ? (
          servicesList?.map(({service, trainer}) => {
            const serviceTrainers = trainer?.filter(
              x =>
                x.branchTrainersBranchId === (branchId || branchIdUrlQuery) &&
                x.availability !== false
            );

            return (
              <React.Fragment key={service?.uuid}>
                {serviceTrainers?.length > 0 && (
                  <Card
                    className={`card-session ${
                      service?.uuid === selectedService?.uuid && 'selected-card'
                    }`}
                    onClick={() => {
                      if (authDetails.authDetails) {
                        dispatch(changeServicePage(service));
                        dispatch(clearClassBookingDetails());
                        history.push('/booking');
                      } else {
                        setTrainerList(trainer);
                        setSelectedService(service);
                      }
                    }}
                    key={service?.uuid}
                    hoverable
                    style={{width: 300, marginRight: 25, marginBottom: 25}}
                  >
                    <Card.Meta
                      title={<span className="font-size-18 txt">{service?.serviceName}</span>}
                      description={
                        <p className="service-scroll font-size-15 txt">{service?.description}</p>
                      }
                    />
                  </Card>
                )}
              </React.Fragment>
            );
          })
        ) : (
          <h3>No services available</h3>
        )
      ) : (
        <h3>No services available</h3>
      )}
    </div>
  );
};

export default PublicSessionsCardList;
